import { Pipe, PipeTransform } from '@angular/core';
import { isFinite } from 'lodash';

@Pipe({
  name: 'numeric'
})
export class NumericPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {

    let noData = (args && args[2]) || 'N/A';
    if (!value && value !== 0) return noData;
    value = +value;

    let type = (args && args[0]) || NUMERIC_TYPES.DECIMAL;
    let decimals = +(args && args[1]) || 0;
    let isDifference = (args && args[3]) || false;

    if (!isFinite(value)) return noData;

    let transformFn = (isDifference && type == NUMERIC_TYPES.PERCENTAGE) ? numericTransforms["PTS"] : numericTransforms[type];
    return transformFn && typeof transformFn === 'function' ? transformFn(value, decimals) : value;
  }
}

export const NUMERIC_TYPES = {
  DECIMAL: 'decimal',
  PERCENTAGE: 'percentage',
  CURRENCY: 'currency',
  THOUSAND: 'thousand',
  COMMA_SEPARATED: 'commaSeparated',
};

const doTransform = (value: number = 0, decimals: number = 0, leftSymbol: string = '', rightSymbol: string = '', placeLeft: boolean = false, placeRight: boolean = false,
) => {
  let minusSign = '';
  //this code change is to show minus sign before the $
  //$-1,066 will be displayed as -$1,066
  if (leftSymbol === '$' && value && value < 0) {
    minusSign = '-';
    value = Math.abs(value);
  }

  if (rightSymbol === 'K' && value && value > 999) {
    value = value / 1000;
    rightSymbol = 'M';
  }

  return `${placeLeft ? minusSign + leftSymbol : minusSign}${value.toFixed(decimals).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}${placeRight ? rightSymbol : ''}`;
};

type numericTransformFn = (number: any, decimals: any) => string;

const numericTransforms: { [key: string]: numericTransformFn } = {
  [NUMERIC_TYPES.DECIMAL]: (a: number, b: number) => doTransform(a, b, '', '', false, false),
  [NUMERIC_TYPES.PERCENTAGE]: (a: number, b: number) => doTransform(100 * a, b, '', '%', false, true),
  ["PTS"]: (a: number, b: number) => doTransform(100 * a, b, '', ' pts', false, true),
  [NUMERIC_TYPES.CURRENCY]: (a: number, b: number) => doTransform(a, b, '$', '', true, false),
  [NUMERIC_TYPES.THOUSAND]: (a: number, b: number) => shorten(a, b),
  [NUMERIC_TYPES.COMMA_SEPARATED]: (a: number, b: number) => doTransform(a, b, '', '', true, false),
};

const NUMERIC_SEPARATORS = {
  ONES: { divisor: 1e0, symbol: '' },
  THOUSANDS: { divisor: 1e3, symbol: 'K' },
  MILLIONS: { divisor: 1e6, symbol: 'M' },
  BILLIONS: { divisor: 1e9, symbol: 'B' }
};

const NUMERIC_SEPARATORS_MAP = {
  0: NUMERIC_SEPARATORS.ONES,
  1: NUMERIC_SEPARATORS.ONES,
  2: NUMERIC_SEPARATORS.ONES,
  3: NUMERIC_SEPARATORS.THOUSANDS,
  4: NUMERIC_SEPARATORS.THOUSANDS,
  5: NUMERIC_SEPARATORS.THOUSANDS,
  6: NUMERIC_SEPARATORS.MILLIONS,
  7: NUMERIC_SEPARATORS.MILLIONS,
  8: NUMERIC_SEPARATORS.MILLIONS,
  9: NUMERIC_SEPARATORS.BILLIONS,
  10: NUMERIC_SEPARATORS.BILLIONS,
  11: NUMERIC_SEPARATORS.BILLIONS,
  12: NUMERIC_SEPARATORS.BILLIONS
}

const shorten = (a: number, b: number) => {
  const separator = NUMERIC_SEPARATORS_MAP[Math.floor(Math.log10(a))] || NUMERIC_SEPARATORS.ONES;
  return doTransform(a / separator.divisor, b, '$', separator.symbol, true, true);
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/numeric.pipe.ts